import { json, checkStatus, IntegrationAPI } from '@driftt/dapper'

export const api = {
    fetchPardotMappings() {
        return IntegrationAPI.get('/pardot/mappings/attributes')
            .then(json)
    },

    patchPardotMappings(mappings) {
        return IntegrationAPI.patch('/pardot/mappings/attributes', mappings)
            .then(checkStatus)
            .then(json)
    },

    fetchPardotFields() {
        return IntegrationAPI.get('/pardot/prospect/fields')
            .then(json)
    },

    fetchPardotProspectCampaigns() {
        return IntegrationAPI.get('/pardot/campaigns')
            .then(json)
    },

    searchPardotProspectCampaigns(name) {
        return IntegrationAPI.post('/pardot/campaigns/search', {
            name,
          })
        .then(json)
    }
}


// WEBPACK FOOTER //
// ./src/scripts/app/modules/pardot/api.js